import React from "react";
import FeatureCallOutContainer from "~/Containers/FeatureCallOutContainer";
import { ThemeProvider, DEFAULT_THEME } from "@zendeskgarden/react-theming";
import { Tooltip } from "@zendeskgarden/react-tooltips";
import "react-toggle/style.css";
import ConfigurationBar from "./ConfigurationBar";

// TO USE THIS TOOLTIP: set isVisible to `show`
const ConfigurationBarWrapper = (props) => (
  <ThemeProvider theme={{ ...DEFAULT_THEME, rtl: true }}>
    <FeatureCallOutContainer
      featureId="totd_nav_config_bar"
      render={({ show, markAsViewed }) => (
        <div>
          <Tooltip
            isInitialVisible={false}
            isVisible={false}
            placement="bottom-start"
            size="large"
            content={
              <>
                <h3>Configuration</h3>
                <p>Set the music player type and home page view style</p>
                <div>
                  <button onClick={markAsViewed}>Thanks</button>
                </div>
              </>
            }
          >
            <div>
              <ConfigurationBar
                daysAgo={props.daysAgo}
                settings={props.settings}
                toggleLayout={props.toggleLayout}
                toggleJukebox={props.toggleJukebox}
                toggleJukeboxAutoPlay={props.toggleJukeboxAutoPlay}
                checkRecent={props.checkRecent}
              />
            </div>
          </Tooltip>
        </div>
      )}
    />
  </ThemeProvider>
);

export default ConfigurationBarWrapper;
